import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "shadow-md text-neutral" }
const _hoisted_2 = { class: "side-panel-item-icon" }
const _hoisted_3 = {
  key: 0,
  class: "side-panel-badge"
}
const _hoisted_4 = { class: "side-panel-item-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavToggle = _resolveComponent("NavToggle")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavToggle, {
      class: "side-panel-toggle",
      shape: "square",
      open: !$setup.isSidebarToggled,
      onToggle: $setup.onSidebarToggle
    }, null, 8, ["open", "onToggle"]),
    _createElementVNode("ul", {
      class: _normalizeClass([
        $setup.isSidebarToggled ? 'w-14' : 'w-52',
        'transition-[width] duration-500 whitespace-nowrap overflow-hidden',
      ])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (menuItem, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createVNode(_component_router_link, {
            to: menuItem.to,
            class: _normalizeClass(["side-panel-item", {
            'side-panel-item--active': $setup.activeTab === menuItem.to.name,
            'side-panel-item--collapsed': $setup.isSidebarToggled,
          }]),
            title: $setup.isSidebarToggled ? menuItem.text : undefined
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("i", {
                  class: _normalizeClass(menuItem.icon)
                }, null, 2),
                (menuItem.beta)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "New!"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(menuItem.text), 1)
            ]),
            _: 2
          }, 1032, ["to", "class", "title"])
        ]))
      }), 128))
    ], 2)
  ]))
}